import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Goals = 'Goals',
  MonteCarlo = 'MonteCarlo',
}

export const queryKeys = {
  monteCarlo: (clientId: string, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.MonteCarlo,
    clientId,
    fpId,
  ],
};
